import React from "react";
import { motion } from 'motion/react';
export function IterativeProgressGraphic({ color = 'rgba(139, 200, 4, 1)', colorLight = 'rgba(189, 232, 111, 1)' }) {
    const colorGlow = color.replace('1)', '0.2)');
    return (React.createElement("div", { style: { padding: '0px', width: '100%', height: '100%' } },
        React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 240 240", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "overflow-visible", preserveAspectRatio: "xMidYMid meet", style: { display: 'block', maxWidth: '100%', maxHeight: '100%' } },
            React.createElement(motion.circle, { cx: "120", cy: "120", r: "30", stroke: colorGlow, strokeWidth: "2", fill: "none", initial: { scale: 0 }, animate: { scale: 1 }, transition: { duration: 0.5 } }),
            [0, 1, 2].map((orbit) => (React.createElement(motion.circle, { key: orbit, cx: "120", cy: "120", r: 60 + orbit * 25, stroke: colorGlow, strokeWidth: "1.5", fill: "none", strokeDasharray: "5,5", initial: { scale: 0, opacity: 0 }, animate: orbit === 1
                    ? { scale: 1, opacity: 1, rotate: [0, 0, 360] }
                    : { scale: 1, opacity: 1 }, transition: orbit === 1
                    ? {
                        scale: { duration: 0.5, delay: orbit * 0.2 },
                        opacity: { duration: 0.5, delay: orbit * 0.2 },
                        rotate: {
                            duration: 5,
                            repeat: Infinity,
                            repeatType: "loop",
                            ease: [0, 0, 0.5, 1],
                            times: [0, 0.6, 1]
                        }
                    }
                    : { delay: orbit * 0.2, duration: 0.5 }, style: { transformOrigin: '120px 120px' } }))),
            [0, 120, 240].map((angle, i) => {
                const radius = 85;
                const x = 120 + radius * Math.cos((angle * Math.PI) / 180);
                const y = 120 + radius * Math.sin((angle * Math.PI) / 180);
                return (React.createElement("g", { key: i },
                    React.createElement(motion.path, { d: `M ${120 + radius * Math.cos(((angle - 30) * Math.PI) / 180)} ${120 + radius * Math.sin(((angle - 30) * Math.PI) / 180)} A ${radius} ${radius} 0 0 1 ${120 + radius * Math.cos(((angle + 30) * Math.PI) / 180)} ${120 + radius * Math.sin(((angle + 30) * Math.PI) / 180)}`, stroke: color, strokeWidth: "3", fill: "none", strokeLinecap: "round", initial: { pathLength: 0 }, animate: { pathLength: 1 }, transition: {
                            delay: i * 0.3,
                            duration: 1,
                            repeat: Infinity,
                            repeatDelay: 2,
                            repeatType: "loop"
                        } }),
                    React.createElement(motion.path, { d: `M ${x - 5} ${y - 8} L ${x + 3} ${y} L ${x - 5} ${y + 8}`, stroke: color, strokeWidth: "3", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", initial: { opacity: 0 }, animate: { opacity: 1 }, transition: {
                            delay: i * 0.3 + 0.8,
                            duration: 0.2,
                            repeat: Infinity,
                            repeatDelay: 2,
                            repeatType: "loop"
                        }, transform: `rotate(${angle + 90} ${x} ${y})` }),
                    React.createElement(motion.circle, { cx: x, cy: y, r: "6", fill: color, initial: { scale: 0 }, animate: {
                            scale: [0, 1.2, 1],
                        }, transition: {
                            delay: i * 0.3,
                            duration: 0.5,
                            repeat: Infinity,
                            repeatDelay: 2.5,
                            repeatType: "loop"
                        } })));
            }),
            React.createElement(motion.g, { initial: { scale: 1 }, animate: {
                    scale: [1, 1.2, 1],
                    opacity: [1, 0.7, 1],
                    rotate: [0, 90, 0]
                }, transition: {
                    duration: 2,
                    repeat: Infinity,
                    repeatType: "loop"
                } },
                React.createElement("g", { transform: "translate(102, 102) scale(2.571)" },
                    React.createElement("path", { d: "M13.98 6.61998V7.35998H8.9L13.6 9.31998L13.32 10.02L8.6 8.05998L12.2 11.68L11.68 12.2L8.06 8.59998L10.02 13.32L9.32 13.6L7.36 8.89998V13.98H6.62V8.89998L4.66 13.6L3.96 13.32L5.92 8.59998L2.3 12.2L1.78 11.68L5.38 8.05998L0.66 10.02L0.38 9.31998L5.08 7.35998H1.49012e-08V6.61998H5.08L0.38 4.65998L0.66 3.95998L5.38 5.91998L1.78 2.29998L2.3 1.77998L5.92 5.37998L3.96 0.65998L4.66 0.37998L6.62 5.07998V-2.07424e-05H7.36V5.07998L9.32 0.37998L10.02 0.65998L8.06 5.37998L11.68 1.77998L12.2 2.29998L8.6 5.91998L13.32 3.95998L13.6 4.65998L8.9 6.61998H13.98ZM8.22 7.23998V6.73998L8.04 6.29998L7.68 5.93998L7.24 5.75998H6.74L6.3 5.93998L5.94 6.29998L5.76 6.73998V7.23998L5.94 7.67998L6.3 8.03998L6.74 8.21998H7.24L7.68 8.03998L8.04 7.67998L8.22 7.23998Z", fill: colorLight }))))));
}
